import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ModelMenuRefreshEventsKeys } from '@src/slide/domain/ui-model/element-modeles/Interface/model-menu-refresh.interface';

export class GroupRefreshMenu {
    public static caculateItemValues = (uiData: IGroupModel) => {
        if (GroupRefreshMenu.isHitModel(uiData)) {
            // 刷新menuManager中缓存的菜单相关属性
            uiData.getMenuManager()?.event?.emit(ModelMenuRefreshEventsKeys.REFRESH_MENU_VALUES_VALUES, uiData);
            // 刷新model各从属模块属性缓存
            uiData.getEffect().refreshMergePropertyValCache(); // effect
            uiData.getBorder().refreshMergePropertyValCache(); // border
            uiData.getMenuManager()?.event.emit(ModelMenuRefreshEventsKeys.REFRESH_MENU_ITEM_VALUES);
        }
    };

    private static isHitModel = (uiData: IGroupModel) =>
        uiData.children?.length && uiData.isRootGroup && uiData.selected;

    private model;
    private refreshTimeout;
    public constructor(model: IGroupModel) {
        this.model = model;
    }

    /**
     * 添加更新组合工具栏数据的监听
     * @param uiData rootGroupModel
     */
    public addRefreshGroupItemValues = () => {
        GroupRefreshMenu.caculateItemValues(this.model);
        this.model.getMenuManager()?.event
            .on(ModelMenuRefreshEventsKeys.REFRESH_GROUP_ITEM_VALUES, this.refreshGroupItemValuesCb);
    };

    /**
     * 移出更新组合工具栏数据的监听
     * @param uiData rootGroupModel
     */
    public removeRefreshGroupItemValues = () => {
        this.model.getMenuManager()?.event
            .off(ModelMenuRefreshEventsKeys.REFRESH_GROUP_ITEM_VALUES, this.refreshGroupItemValuesCb);
    };

    /**
     * 刷新model的itemValue缓存，即工具栏信息缓存
     */
    private refreshGroupItemValuesCb = () => {
        if (!GroupRefreshMenu.isHitModel(this.model)) {
            return;
        }
        clearTimeout(this.refreshTimeout);
        this.refreshTimeout = setTimeout(() => {
            GroupRefreshMenu.caculateItemValues(this.model);
        }, 30);
    };
}
